// extracted by mini-css-extract-plugin
module.exports = {"wrapperItem":"uploadItem_wrapperItem__2yBZu","leftSide":"uploadItem_leftSide__1HYGu","progressBar":"uploadItem_progressBar__1nN-h","percentage":"uploadItem_percentage__3uPog"};